import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';

function OsideIndia() {
    window.scrollTo(0, 0);
    return (
        <div className='oside-india-page'>
            <Helmet>

                <title>Oside India</title>
                <meta name="description" content="" />
                {/* <link rel="canonical" href="https://anbluxury.com/case-studies/adani-realty-case-study.html" /> */}

            </Helmet>

            <div className="page-container">
                <div className="bloc padl padr fullscreen-bg d-bloc hero" id="hero-bloc">
                    <div className="box">

                        <img src={`${process.env.PUBLIC_URL}/img/luxury-digital-marketing.avif`} alt="" className="vdtp" id="finalv" width="100%" height="100%">
                        </img>
                        <div className="oside-centered">
                            <h2>OSIDE</h2>
                            <p>Helping luxury & premium brands target the right audience.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="box  problem clutter-bg">
                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-bg.avif`}></img>
                <div className='solution-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className=''>The Problem</h2>
                    </div>
                </div>
            </div>

            <div className=" bgb specialist">
                <ProblemSlider />
            </div>

            <div className="lgbox">
                <Container fluid className="tpfold pdr0 pb-5 mbpdr15">
                    <Row>
                        <Col lg="12" className="padmmdt mbpt0 casebox">
                            <p className="text-center p1 mrg30 " > <span class="">Income Split by State and Cities</span> </p>
                        </Col>
                        <Col lg="4" md="4" sm="6" xs="12" className="income-split-img padmmdt mbpt0 casebox offset-lg-1">
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/oside/income-split1.avif`} width="100%" height="100%" className="img-fluid text-right" />
                        </Col>
                        <Col lg="5" md="4" sm="6" xs="12" className="income-split-img padmmdt mbpt0 casebox offset-lg-1">
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/oside/income-split2.avif`} width="100%" height="100%" className="img-fluid text-right" />
                        </Col>
                    </Row>
                </Container>
            </div>


            {/* The opportunity */}


            <div className="box clutter-bg clutter-bg-desk">
                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-clutter-bg.avif`}></img>
                <div className='clutter-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className='text-center'>This Clutter Leads To</h2>
                    </div>
                    <div className='clutter-bg-body'>
                        <Row>
                            <Col lg="3" md="3" sm="6" xs="6" className='mt-5'>
                                <h4>Wasted spends and <br></br> wasted remarketing</h4>
                            </Col>
                            <Col lg="3" md="3" sm="6" xs="6" className='mt-5'>
                                <h4>Low Ecommerce <br></br>  Conversion Rate</h4>
                            </Col>
                            <Col lg="3" md="3" sm="6" xs="6" className='mt-5'>
                                <h4>Poor ROI on paid  <br></br> advertising</h4>
                            </Col>
                            <Col lg="3" md="3" sm="6" xs="6" className='mt-5'>
                                <h4>Poor quality of  <br></br> social interaction</h4>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            <div className="box  problem clutter-bg">
                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-solution-bg.avif`}></img>
                <div className='solution-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className=''>The Solution</h2>
                    </div>
                </div>
            </div>

            <div className="box solution-oside-div">
                <Container fluid className="tpfold solution-oside">
                    <h1>OSIDE</h1>
                    <p>Helping Luxury & Premium Brands Target The Right Audience.
                    </p>
                </Container>
            </div>


            <div className="box  problem clutter-bg clutter-bg-desk">
                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-profile-bg.avif`}></img>
                <div className='clutter-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className='text-center'>Profiling these users across the web</h2>
                    </div>
                    <div className='clutter-bg-body'>
                        <Row>
                            <Col lg="3" md="3" sm="6" className='mt-5'>
                                <h4>Demographics</h4>
                                <p>Age</p>
                                <p>Gender</p>
                                <p>Education</p>
                                <p>Marital Status</p>
                                <p>Pin Codes</p>
                                <p>Designation</p>
                            </Col>
                            <Col lg="3" md="3" sm="6" className='mt-5'>
                                <h4>Interest</h4>
                                <p>Lifetime Interest</p>
                                <p>Recent Interest</p>
                                <p>Deep Interest</p>
                                <p>Shallow Interest</p>
                            </Col>
                            <Col lg="3" md="3" sm="6" className='mt-5'>
                                <h4>Intent</h4>
                                <p>Intent</p>
                                <p>Qualified Intent</p>
                            </Col>
                            <Col lg="3" md="3" sm="6" className='mt-5'>
                                <h4>Income</h4>
                                <p>Devices</p>
                                <p>Credit Card</p>
                                <p>Car</p>
                                <p>Gadgets</p>
                                <p>Holiday Destinations</p>
                                <p>Smart Homes</p>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            <div className="lgbox oside-pincode-table">
                <Container fluid className="tpfold pdr0 pb-5 mbpdr15">
                    <Row>
                        <Col lg="12" className="padmmdt mbpt0 casebox">
                            <p className="text-center p1 mrg30 " > <span class="">Pincodes with HNIs & UHNIs</span> </p>
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="padmmdt mbpt0 casebox table-overflow offset-lg-1">
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: 'center' }} colSpan={12}>Bangalore</th>
                                    </tr>
                                    <tr>
                                        <th>Area</th>
                                        <th>PSF</th>
                                        <th>Pincodes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr><td>Lavelle Road</td><td>Rs. 24,500 – 26,650/sq.ft.</td><td>560001</td></tr>
                                    <tr><td>Shanthala Nagar</td><td>Rs. 22,900 – 32,000/sq.ft.</td><td>560025</td></tr>
                                    <tr><td>Cunningham Road</td><td>Rs. 20,700 – 22,300/sq.ft.</td><td>560052</td></tr>
                                    <tr><td>Sadashiva Nagar</td><td>Rs. 17,200 – 21,200/sq.ft.</td><td>560025</td></tr>
                                    <tr><td>Chikku Lakshmaiah Layout</td><td>Rs. 16,600 – 18,350/sq.ft.</td><td>560029</td></tr>
                                    <tr><td>Halasur</td><td>Rs. 16,600 – 18,700/sq.ft.</td><td>560007</td></tr>
                                    <tr><td>Sampangi Rama Nagar</td><td>Rs. 16,050 – 19,800/sq.ft.</td><td>560027</td></tr>
                                    <tr><td>Adugodi</td><td>Rs. 15,350 – 17,700/sq.ft.</td><td>560030</td></tr>
                                    <tr><td>Defence Colony</td><td>Rs. 15,100 – 18,550/sq.ft.</td><td>560038</td></tr>
                                    <tr><td>Abshot Layout</td><td>Rs. 15,000 – 20,650/sq.ft.</td><td>560052</td></tr>
                                    <tr><td>Vasanth Nagar</td><td>Rs. 14,750 – 20,850/sq.ft.</td><td>560052</td></tr>
                                </tbody>
                            </table>
                        </Col>
                        <Col lg="5" md="4" sm="12" xs="12" className="padmmdt mbpt0 table-overflow casebox offset-lg-1">
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: 'center' }} colSpan={12}>Mumbai</th>
                                    </tr>
                                    <tr>
                                        <th>Area</th>
                                        <th>PSF</th>
                                        <th>Pincode</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr><td>Altamount Road</td><td>Rs. 74,100 – 83,550/sq.ft.</td><td>400026</td></tr>
                                    <tr><td>Chamundeshwari Nagar</td><td>Rs. 62,650 – 75,200/sq.ft.</td><td>400005</td></tr>
                                    <tr><td>Marine Drive Chowpatty</td><td>Rs. 52,150 – 67,050/sq.ft.</td><td>400007</td></tr>
                                    <tr><td>Malabar Hill</td><td>Rs. 52,100 – 65,300/sq.ft.</td><td>400006</td></tr>
                                    <tr><td>Kemps Corner</td><td>Rs. 51,950 – 65,550/sq.ft.</td><td>400006</td></tr>
                                    <tr><td>Marine Drive</td><td>Rs. 51,500 – 65,400/sq.ft.</td><td>400020</td></tr>
                                    <tr><td>Cuffe Parade</td><td>Rs. 51,100 – 64,400/sq.ft.</td><td>400005</td></tr>
                                    <tr><td>Breach Candy</td><td>Rs. 50,800 – 56,650/sq.ft.</td><td>400026</td></tr>
                                    <tr><td>Napean Sea Road</td><td>Rs. 48,250 – 56,450/sq.ft.</td><td>400036</td></tr>
                                    <tr><td>Peddar Road</td><td>Rs. 47,400 – 56,650/sq.ft.</td><td>400026</td></tr>
                                    <tr><td>Walkeshwar</td><td>Rs. 46,200 – 56,450/sq.ft.</td><td>400006</td></tr>
                                    <tr><td>Chowpatty</td><td>Rs. 45,700 – 59,650/sq.ft.</td><td>400004</td></tr>
                                    <tr><td>Gandhi Nagar</td><td>Rs. 43,350 – 48,850/sq.ft.</td><td>400018</td></tr>
                                    <tr><td>Churchgate</td><td>Rs. 43,350 – 49,650/sq.ft.</td><td>400020</td></tr>
                                    <tr><td>Mantralaya</td><td>Rs. 43,450 – 59,650/sq.ft.</td><td>400032</td></tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="lgbox">
                <Container fluid className="tpfold pdr0 pb-5 mbpdr15">
                    <Row>
                        <Col lg="12" className="padmmdt mbpt0 casebox">
                            <p className="text-center p1 mrg30 " > <span class="">Profiling these users across the web</span> </p>
                        </Col>

                        <Col lg='1'></Col>

                        <Col lg="10" md="12" sm="12" xs="12" className="padmmdt mbpt0 casebox">
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/oside/oside-chart.png`} width="100%" height="100%" className="img-fluid text-right" />
                        </Col>

                        <Col lg='1'></Col>
                    </Row>
                </Container>
            </div>


            <div className="box">
                <Container fluid className="tpfold pdr0 pb-5 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="6" xs="12" className="padmmdt mbpt0 casebox offset-lg-1">
                            <Container fluid className="tpfold solution-oside oside-social-head">
                                <h1>OSIDE</h1>
                                <p>Targets the right audience across more than 100 platforms
                                </p>
                            </Container>
                        </Col>
                        <Col lg="5" md="4" sm="6" xs="12" className="padmmdt mbpt0 casebox offset-lg-1">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/oside-social-logos.png`} />
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="box  problem clutter-bg clutter-bg-desk">
                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-profile-bg.avif`}></img>
                <div className='clutter-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className='text-center'>Why OSIDE?</h2>
                    </div>
                    <div className='clutter-bg-body'>
                        <Row>
                            <Col lg="4" md="4" sm="12" xs="12" className='mt-5'>
                                <h4>Build Brand for the <br></br> Right Audience.</h4>
                                <p>Much higher brand lift</p>
                                <p>Reach real consumers</p>
                            </Col>
                            <Col lg="4" md="4" sm="12" xs="12" className='mt-5'>
                                <h4>You get Buyers, <br></br> Not Browsers.</h4>
                                <p>Higher repeat purchases</p>
                                <p>Lower CAC</p>
                            </Col>
                            <Col lg="4" md="4" sm="12" xs="12" className='mt-5'>
                                <h4>Do the impossible on  <br></br> advertising </h4>
                                <p>Only Shopping clicks on PMax</p>
                                <p>Fraud pin-code exclusion</p>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            <div className="box clutter-bg clutter-bg-desk">
                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-profile-bg.avif`}></img>
                <div className='clutter-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className='text-center'>OSIDE Brand Safety Features</h2>
                    </div>
                    <div className='clutter-bg-body'>
                        <Row>
                            <Col lg="4" md="4" sm="6" className='mt-5'>
                                <h4>Bot Safety</h4>
                                <p>Excludes bot infested pin-codes</p>
                                <p>Forces user-signed in</p>
                            </Col>
                            <Col lg="4" md="4" sm="6" className='mt-5'>
                                <h4>Content Safety</h4>
                                <p>Avoids profane content</p>
                                <p>Has a placement blacklist</p>
                            </Col>
                            <Col lg="4" md="4" sm="6" className='mt-5'>
                                <h4>Ad Safety</h4>
                                <p>Real Impressions</p>
                                <p>Cancels muted impressions</p>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>


            <div className="box  problem clutter-bg">
                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-profile-bg.avif`}></img>
                <div className='clutter-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className='text-center'>OSIDE Dashboard</h2>
                    </div>
                    <div className='clutter-bg-body'>
                        <Row>
                            <Col lg='1'></Col>
                            <Col lg="10" md="12" sm="12" xs="12" className=''>
                                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-dashboard.png`} />
                            </Col>
                            <Col lg='1'></Col>
                        </Row>
                    </div>
                </div>

            </div>

            <div className="box  problem clutter-bg">
                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-ml-bg.avif`}></img>
                <div className='solution-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className=''>The technology: <br></br>
                            ML + HE
                        </h2>
                        <p style={{ textAlign: 'initial' }}><i>Machine Learning meets Human Experience
                        </i></p>
                    </div>
                </div>
            </div>


            <div className="lgbox">
                <Container fluid className="tpfold pb-5 mbpdr15">
                    <Row>
                        <Col lg="12" className="padmmdt mbpt0 casebox">
                            <p className="text-center p1 mrg30 " > <span class="">Comparison Between Vanilla Digital Campaigns and OSIDE </span> </p>
                        </Col>
                    </Row>

                    <div className='clutter-bg-body oside-comparison-body'>
                        <table className='oside-comparison-table'>
                            <tr>
                                <th>Criteria</th>
                                <th>Vanilla Campaigns</th>
                                <th>OSIDE</th>
                            </tr>
                            <tr>
                                <td>Income Targeting</td>
                                <td>Broad, untargeted</td>
                                <td>Pin-code + Device + Spend profiling</td>
                            </tr>
                            <tr>
                                <td>User Quality</td>
                                <td>Browsers</td>
                                <td>Buyers</td>
                            </tr>
                            <tr>
                                <td>Ad Placements</td>
                                <td>Irrelevant, often muted/skipped</td>
                                <td>High-intent platforms only</td>
                            </tr>
                            <tr>
                                <td>Bot/Spam Filtering</td>
                                <td>Weak</td>
                                <td>Bot blacklist</td>
                            </tr>
                            <tr>
                                <td>Content Safety</td>
                                <td>Profane, unsafe, often junk inventory</td>
                                <td>Curated, brand-safe publishers</td>
                            </tr>
                            <tr>
                                <td>Geo Targeting</td>
                                <td>Wide net, no refinement</td>
                                <td>Hyper-local (HNI/UHNI pin-codes)</td>
                            </tr>
                            <tr>
                                <td>CAC</td>
                                <td>High</td>
                                <td>Lower with high-conversion users</td>
                            </tr>
                            <tr>
                                <td>Remarketing</td>
                                <td>Wasted on low-intent users</td>
                                <td>Deep intent qualified remarketing</td>
                            </tr>
                            <tr>
                                <td>Brand Lift</td>
                                <td>Minimal</td>
                                <td>Significant lift with the right users</td>
                            </tr>
                            <tr>
                                <td>Data Access</td>
                                <td>Fragmented</td>
                                <td>Real-time OSIDE dashboard</td>
                            </tr>
                        </table>
                    </div>
                </Container>
            </div>

            <div className="lgbox">
                <Container fluid className="tpfold pb-5 mbpdr15">
                    <Row>
                        <Col lg="12" className="padmmdt mbpt0 casebox">
                            <h2 className='text-center'>How will it work?</h2>
                        </Col>
                    </Row>

                    <div className='clutter-bg-body'>
                        <Row>
                            <Col lg='1'></Col>
                            <Col lg="10" md="12" sm="12" xs="12" className=''>
                                <img src={`${process.env.PUBLIC_URL}/img/oside/oside-work-flow.png`} />
                            </Col>
                            <Col lg='1'></Col>
                        </Row>
                    </div>

                </Container>
            </div>

            <div className="box  problem clutter-bg">
                <img src={`${process.env.PUBLIC_URL}/img/luxury-digital-marketing.avif`}></img>
                <div className='oside-20-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className=''>Case Studies
                        </h2>
                    </div>
                </div>
            </div>

            <div id="clients" className="clients bgclients padmsmt padmsmb">
                <Col lg="10" xs="12" className="offset-lg-1" >
                    <h3 className="txtcolor text-center mb-3">Mumbai | London | Dubai | Brisbane</h3>
                </Col>
                <Container>
                    <ul className='clients-list'>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/adani-logo.avif`} alt="" className="img-fluid cbnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/district-purple.avif`} alt="" className="img-fluid clnimg1" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/atmantan.avif`} alt="" className="img-fluid cbnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/blabel.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/bovetlogo.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/Isaia.avif`} alt="" className="img-fluid  cbnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/evok.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/johnlobb.avif`} alt="" className="img-fluid  cbnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/levis.avif`} alt="" className="img-fluid cbnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/kitonlogo.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/paytminsider.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/marico.avif`} alt="" className="img-fluid cbnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/queo.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/myntra.avif`} alt="" className="img-fluid clnimg1" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/weekender.avif`} alt="" className="img-fluid clnimg1" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/Regalia.avif`} alt="" className="img-fluid cbnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/ressence.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/sarda-white.avif`} alt="" className="img-fluid clnimg1" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/saundhlogo.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/vice.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/limelight.avif`} alt="" className="img-fluid clnimg" />
                        </li>

                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/warner-bros.avif`} alt="" className="img-fluid clnimg1" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/ceew.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/squareoff.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/morgon_co.avif`} alt="" className="img-fluid clnimg1" />
                        </li>

                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/Aprilia.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/Carysil.avif`} alt="" className="img-fluid clnimg1" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/Gerald-Charles.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/Vespa.avif`} alt="" className="img-fluid clnimg" />
                        </li>
                        <li className='clients-item'>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/clients/raiaskaran.avif`} alt="" className="img-fluid clnimg1" />
                        </li>
                    </ul>

                </Container>
            </div>


            <div className=" bgb specialist">
                <Specialist />
            </div>


            <div className="box">
                <Container fluid className="tpfold pdr0 pb-5 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="6" xs="12" className="padmmdt mbpt0 casebox offset-lg-1">
                            <Container fluid className="tpfold solution-oside oside-social-head">
                                <h3>Tech Integration</h3>
                                <p style={{ textAlign: 'left' }}>Integrates with your email/analytics/commerce stack to deliver a comprehensive reporting.
                                </p>
                            </Container>
                        </Col>
                        <Col lg="5" md="4" sm="6" xs="12" className="padmmdt mbpt0 casebox offset-lg-1">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/oside-tech-logos.png`} />
                        </Col>
                    </Row>
                </Container>
            </div>


            <div className="box  problem clutter-bg">
                <img src={`${process.env.PUBLIC_URL}/img/luxury-digital-marketing.avif`}></img>
                <div className='oside-20-bg-content'>
                    <div className='clutter-bg-head p-5'>
                        <h2 className=''>Let’s target the top 1%.
                        </h2>
                    </div>
                </div>
            </div>
            
        </div>

    )
}
export default OsideIndia;

function ProblemSlider() {
    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <button
            {...props}
            className={
                "slick-prev slick-arrow" +
                (currentSlide === 0 ? " slick-disabled" : "")
            }
            aria-hidden="true"
            aria-disabled={currentSlide === 0 ? true : false}
            type="button"
        >
            Previous
        </button>
    );
    const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <button
            {...props}
            className={
                "slick-next slick-arrow" +
                (currentSlide === slideCount - 1 ? " slick-disabled" : "")
            }
            aria-hidden="true"
            aria-disabled={currentSlide === slideCount - 1 ? true : false}
            type="button"
        >
            Next
        </button>
    );
    const settings = {
        dots: true,
        //   lazyLoad: "progressive",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
        prevArrow: <SlickArrowLeft />,
        nextArrow: <SlickArrowRight />,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    adaptiveHeight: true,
                }
            },]
    };
    const next = () => {
        Slider.current.slickNext();
    }
    const previous = () => {
        Slider.current.slickPrev();
    }
    return (
        <Container fluid className="pdlr0 bgservices">

            <Slider {...settings}>
                <div>
                    <div className="homepgesecond">
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-slide1.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-slide1.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">55% <br></br>
                                of digital marketing budget spent by Luxury & Premium brands is wasted.
                            </h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-slide2.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-slide2.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Due to clutter, <br></br>

                                the budget reaches the wrong audience.

                            </h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <h2>Clutter</h2>
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-slide3.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-slide3.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">120 Crore  <br></br>
                                Indians are online now.
                            </h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <h2>Clutter</h2>
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-slide3.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-problem-slide3.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">120 Crore  <br></br>
                                People are not your target audience.

                            </h2>
                        </div>
                    </div>
                </div>
            </Slider>


        </Container>
    );
}

function Specialist() {
    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <button
            {...props}
            className={
                "slick-prev slick-arrow" +
                (currentSlide === 0 ? " slick-disabled" : "")
            }
            aria-hidden="true"
            aria-disabled={currentSlide === 0 ? true : false}
            type="button"
        >
            Previous
        </button>
    );
    const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <button
            {...props}
            className={
                "slick-next slick-arrow" +
                (currentSlide === slideCount - 1 ? " slick-disabled" : "")
            }
            aria-hidden="true"
            aria-disabled={currentSlide === slideCount - 1 ? true : false}
            type="button"
        >
            Next
        </button>
    );
    const settings = {
        dots: true,
        //   lazyLoad: "progressive",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
        prevArrow: <SlickArrowLeft />,
        nextArrow: <SlickArrowRight />,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    adaptiveHeight: true,
                }
            },]
    };
    const next = () => {
        Slider.current.slickNext();
    }
    const previous = () => {
        Slider.current.slickPrev();
    }
    return (
        <Container fluid className="pdlr0 bgservices">

            <Slider {...settings}>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-adani-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-adani-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-adani-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Million Dollar Villas - Sold to Multi-Millionaires.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-bovet-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-bove-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-bove-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">3x rise in Revenue for Bovet Watches</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-kapoor-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-kapoor-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-kapoor-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">5x D2C Scale + International Growth.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-isaia-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-isai-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-isai-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">100% Jump in Walkins in 4 Months.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-vespa-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-vespa-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-vespa-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Driving Digital Transformation</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-scarlet-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-scarlet-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-scarlet-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">30% jump in qualified leads in 3 months.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-morgan-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-morgan-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-morgan-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">India and Dubai pre sales Through the Roof</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-squareoff-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-squareoff-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-squareoff-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Scaled advertising in Europe & USA</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-atmantan-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-atmantan-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-atmantan-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">100% jump in International visitors</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-queo-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-queo-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-queo-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Scaled Qualified visitors by 3x.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-aprilia-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-aprilia-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-aprilia-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Driving Digital Transformation</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-limelight-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-limelight-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-limelight-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Scaled non-existent ecommerce.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-levis-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-levis-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-levis-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Circles Campaign Launched on Snapchat.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-raiskaran-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-raiskaran-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-raiskaran-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">$10M Family Offices. Workplace Luxury.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-evok-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-evok-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-evok-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Scaled  Ecommerce revenue by 921%.</h2>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="homepgesecond">
                        <div className="oside-case-study-logo">
                            <img src={`${process.env.PUBLIC_URL}/img/oside/client-logo/oside-wb-logo.png`} />
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-wb-bg.avif`} width="100%" height="100%" className=" d-none d-sm-block" />
                        <img src={`${process.env.PUBLIC_URL}/img/oside/oside-wb-bg.avif`} width="100%" height="100%" className="d-block  d-sm-none" />
                        <div className="oside-case-study-head">
                            <h2 className="">Justice League Video Teaser Campaign.</h2>
                        </div>
                    </div>
                </div>
            </Slider>


        </Container>
    );
}